export default __webpack_public_path__ + "static/media/khoomi.7afc65f1.png";